module.exports = __webpack_public_path__ + "img/consulta_precios.988d4bf7.png";